export default class AlertasApi {
  static limpaAlertas(){
    return dispatch => {
      dispatch({type:'CLEANMSGS'});
      return true
    }
  }
}


// WEBPACK FOOTER //
// ./src/logicas/Alertas/AlertasApi.js